/**全局是or否。1是2否 */
export enum YN {
  'Yes' = 1,
  'No' = 2
}

/**
 * 角色编码
 */
export enum RoleCode {
  /**普通用户 */
  User = '00101'
}

/**
 * menu 类型
 */
export const enum MenuType {
  TOP_TYPE = 1,
  PAGE_TYPE = 2,
  BUTTON_TYPE = 3
}
